exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tokenizador-helper[data-v-77045d7b] {\n  font-size: 14px;\n  font-style: oblique;\n}", ""]);

// exports
